import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from '../../lib/cn.js';
import styles from './ListRow.module.css';
/** Row inside a list card — leading icon tile, two-line text, trailing
 * action/status (CLAUDE_DESIGN.md §6.7). */
export function ListRow({ icon, title, meta, trailing, onClick, className }) {
    const content = (_jsxs(_Fragment, { children: [icon && _jsx("span", { className: styles['icon'], children: icon }), _jsxs("span", { className: styles['text'], children: [_jsx("span", { className: styles['title'], children: title }), meta && _jsx("span", { className: styles['meta'], children: meta })] }), trailing && _jsx("span", { className: styles['trailing'], children: trailing })] }));
    if (onClick) {
        return (_jsx("button", { type: "button", onClick: onClick, className: cn(styles['row'], styles['interactive'], className), children: content }));
    }
    return _jsx("div", { className: cn(styles['row'], className), children: content });
}
